module.exports = __webpack_public_path__ + "static/media/heidi26.c300449e.JPG";